export var activitySourceAdvisorDefaultConfig = {
    firstQuestion: 0,
    questions: [
        {
            id: 0,
            text: 'Какое у вас устройство для записи тренировок?',
            variants: [
                {
                    id: 0,
                    text: 'Смарт-часы или браслет'
                },
                {
                    id: 1,
                    text: 'У меня только телефон'
                },
            ]
        },
        {
            id: 1,
            text: 'Какой у вас смартфон?',
            variants: [
                {
                    id: 0,
                    text: 'iPhone'
                },
                {
                    id: 1,
                    text: 'Телефон на Android'
                },
            ]
        },
        {
            id: 2,
            text: 'Какие у вас часы?',
            variants: [
                {
                    id: 0,
                    text: 'Garmin'
                },
                {
                    id: 1,
                    text: 'Polar'
                },
                {
                    id: 2,
                    text: 'Xiaomi Smart Band'
                },
                {
                    id: 3,
                    text: 'Другие'
                },
            ]
        },
        {
            id: 3,
            text: 'Сигнал GPS в моём городе...',
            variants: [
                {
                    id: 0,
                    text: 'Стабильный, без помех, всегда идеальный трек'
                },
                {
                    id: 1,
                    text: 'Плохой, устройство либо вовсе не ловит GPS, либо время от времени сбивается трек'
                },
            ]
        },
    ],
    /**
     * paths - содержит список возможных путей вопрос-ответ [x,y], где x - ID вопроса (из questions), а y - ответ(из variants)
     */
    paths: [
        {
            id: 0,
            paths: [
                [
                    [0, 0],
                    [2, 0],
                    [1, 0],
                    [3, 0],
                ],
            ],
            reply: 0,
            description: 'часы гармин с iPhone и хороший GPS'
        },
        {
            id: 1,
            paths: [
                [
                    [0, 0],
                    [2, 0],
                    [1, 0],
                    [3, 1],
                ],
            ],
            reply: 1,
            description: 'часы гармин с iPhone и плохой GPS'
        },
        {
            id: 2,
            paths: [
                [
                    [0, 0],
                    [2, 1],
                    [1, 0],
                    [3, 0],
                ],
            ],
            reply: 2,
            description: 'часы полар с iPhone и хороший GPS'
        },
        {
            id: 3,
            paths: [
                [
                    [0, 0],
                    [2, 1],
                    [1, 0],
                    [3, 1],
                ],
            ],
            reply: 3,
            description: 'часы полар с iPhone и плохой GPS'
        },
        {
            id: 4,
            paths: [
                [
                    [0, 0],
                    [2, 2],
                    [1, 0],
                    [3, 0],
                ],
                [
                    [0, 0],
                    [2, 2],
                    [1, 0],
                    [3, 1],
                ],
            ],
            reply: 4,
            description: 'часы Xiaomi Smart Band с iPhone и любой GPS'
        },
        {
            id: 5,
            paths: [
                [
                    [0, 0],
                    [2, 3],
                    [1, 0],
                    [3, 0],
                ],
                [
                    [0, 0],
                    [2, 3],
                    [1, 0],
                    [3, 1],
                ],
            ],
            reply: 5,
            description: 'другие часы с iPhone и любой GPS'
        },
        {
            id: 6,
            paths: [
                [
                    [0, 0],
                    [2, 0],
                    [1, 1],
                    [3, 0],
                ],
            ],
            reply: 6,
            description: 'часы гармин с Android и хороший GPS'
        },
        {
            id: 6,
            paths: [
                [
                    [0, 0],
                    [2, 0],
                    [1, 1],
                    [3, 1],
                ],
            ],
            reply: 6,
            description: 'часы гармин с Android и плохой GPS'
        },
        {
            id: 7,
            paths: [
                [
                    [0, 0],
                    [2, 1],
                    [1, 1],
                    [3, 0],
                ],
            ],
            reply: 2,
            description: 'часы полар с Android и хороший GPS'
        },
        {
            id: 8,
            paths: [
                [
                    [0, 0],
                    [2, 1],
                    [1, 1],
                    [3, 1],
                ],
            ],
            reply: 3,
            description: 'часы полар с Android и плохой GPS'
        },
        {
            id: 9,
            paths: [
                [
                    [0, 0],
                    [2, 2],
                    [1, 1],
                    [3, 0],
                ],
                [
                    [0, 0],
                    [2, 2],
                    [1, 1],
                    [3, 1],
                ],
            ],
            reply: 8,
            description: 'часы Xiaomi Smart Band с Android и любой GPS'
        },
        {
            id: 10,
            paths: [
                [
                    [0, 0],
                    [2, 3],
                    [1, 1],
                    [3, 0],
                ],
                [
                    [0, 0],
                    [2, 3],
                    [1, 1],
                    [3, 1],
                ],
            ],
            reply: 9,
            description: 'другие часы с Android и любой GPS'
        },
        {
            id: 11,
            paths: [
                [
                    [0, 1],
                    [1, 0],
                    [3, 0],
                ],
            ],
            reply: 10,
            description: 'только iPhone и хороший GPS'
        },
        {
            id: 12,
            paths: [
                [
                    [0, 1],
                    [1, 0],
                    [3, 1],
                ],
            ],
            reply: 11,
            description: 'только iPhone и плохой GPS'
        },
        {
            id: 13,
            paths: [
                [
                    [0, 1],
                    [1, 1],
                    [3, 0],
                ],
            ],
            reply: 10,
            description: 'только Android и хороший GPS'
        },
        {
            id: 14,
            paths: [
                [
                    [0, 1],
                    [1, 1],
                    [3, 1],
                ],
            ],
            reply: 10,
            description: 'только Android и плохой GPS'
        },
    ],
    replies: [
        {
            id: 0,
            text: '1. Strava  2. Apple Health + GoogleFit',
            description: '1. Strava  2. Apple Health + GoogleFit'
        },
        {
            id: 1,
            text: '1. Strava  2. Apple Health + GoogleFit + запрашивать валидацию администратором, если не корректная дистанция',
            description: '1. Strava  2. Apple Health + GoogleFit + запрашивать валидацию администратором, если не корректная дистанция'
        },
        {
            id: 2,
            text: 'Polar Flow',
            description: 'Polar Flow'
        },
        {
            id: 3,
            text: 'Polar Flow + запрашивать валидацию администратором, если не корректная дистанция',
            description: 'Polar Flow + запрашивать валидацию администратором, если не корректная дистанция'
        },
        {
            id: 4,
            text: 'Mi Fitness + Apple Health + Google Fit',
            description: 'Mi Fitness + Apple Health + Google Fit'
        },
        {
            id: 5,
            text: 'Если китайские то Mi Fitness, если другие - Strava или другое приложение (пользователю нужно разобраться самостоятельно) и Apple Health + GoogleFit',
            description: 'Если китайские то Mi Fitness, если другие - Strava или другое приложение (пользователю нужно разобраться самостоятельно) и Apple Health + GoogleFit'
        },
        {
            id: 6,
            text: 'Strava',
            description: 'Strava'
        },
        {
            id: 7,
            text: 'Strava + запрашивать валидацию администратором, если не корректная дистанция',
            description: 'Strava + запрашивать валидацию администратором, если не корректная дистанция'
        },
        {
            id: 8,
            text: 'Mi Fitness + Google Здоровье и спорт + Наше приложение Импульс',
            description: 'Mi Fitness + Google Здоровье и спорт + Наше приложение Импульс'
        },
        {
            id: 9,
            text: 'Если китайские то Mi Fitness, если другие - Strava или другое приложение (пользователю нужно разобраться самостоятельно) Google Здоровье и спорт или Google Fit + Наше приложение Импульс',
            description: 'Если китайские то Mi Fitness, если другие - Strava или другое приложение (пользователю нужно разобраться самостоятельно) Google Здоровье и спорт или Google Fit + Наше приложение Импульс'
        },
        {
            id: 10,
            text: 'Polar Beat',
            description: 'Polar Beat'
        },
        {
            id: 11,
            text: 'StepsApp + AppleHealth + GoogleFit',
            description: 'StepsApp + AppleHealth + GoogleFit'
        },
        {
            id: 12,
            text: 'GoogleFit + Google Здоровье и Спорт + Наше приложение Импульс',
            description: 'GoogleFit + Google Здоровье и Спорт + Наше приложение Импульс'
        },
    ]
};
